import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Complaint, ComplaintFilters, ComplaintsDocumentType, ComplaintUserType, DocumentStatus } from '@icc/b2b/shared';
import { ComplaintPartyExtended } from 'libs/b2b/shared/src/lib/models/complaint-party';
import { ComplaintService } from '../complaint.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from '@icc/shared';

@Component({
    selector: 'icc-complaint-filters',
    templateUrl: './complaint-filters.component.html',
    styleUrls: ['./complaint-filters.component.scss'],
})
export class ComplaintFiltersComponent implements OnChanges {
    @Output() showMap = new EventEmitter<boolean>();
    @Input() isShowMap = false;

    client = '';
    nrOrder = '';
    distributorOrRetailer = '';
    status = 0;
    creationDateFrom: Date = null;
    creationDateTo: Date = null;
    assignedUserId = 0;
    userTypeCompanyId = 0;
    assignedTo: ComplaintUserType | null = null;
    companyId = 0;
    complaintType: ComplaintsDocumentType | 0 = 0;
    filteredContractorsList: ComplaintPartyExtended[] = [];
    filteredContractors: ComplaintPartyExtended[] = [];
    accountManagerPersonId = 0;
    protected _filters: ComplaintFilters;

    @Input() isOrderList = false;
    @Input() isInquiryList = false;
    @Input() workersList: Record<string, string> | null = null;
    @Input() contractorsList: ComplaintPartyExtended[] = [];
    @Input()
    get filters(): ComplaintFilters {
        return this._filters;
    }
    set filters(filters: ComplaintFilters) {
        this.setFilters(filters);
    }
    @Input() documentStatuses: DocumentStatus[];

    @Input() side: 'purchase' | 'sales' = 'sales';

    @Input() showDocumentStatuses: boolean;
    @Input() userType: ComplaintUserType;
    @Output() filtersEmitter = new EventEmitter<{
        filters: ComplaintFilters;
        reset: boolean;
    }>();

    constructor(
        private complaintService: ComplaintService,
        private router: Router,
        private route: ActivatedRoute,
        private config: ConfigService
    ) {

    }

    ngOnChanges(): void {
        this.filteredContractorsList = this.contractorsList;
        this.filteredContractors = this.getContractorsList();
    }

    setFilters(filters: ComplaintFilters) {
        if (filters) {
            this._filters = filters;
            this.nrOrder = filters.nrOrder;
            this.status = filters.status;
            this.creationDateFrom = filters.creationDateFrom;
            this.creationDateTo = filters.creationDateTo;
            this.client = filters.client;
            this.distributorOrRetailer = filters.distributorOrRetailer;
            this.assignedUserId = filters.assignedUserId;
            this.userTypeCompanyId = filters.userTypeCompanyId;
            this.assignedTo = filters.assignedTo;
            this.companyId = filters.companyId;
            this.complaintType = filters.complaintType;
            this.accountManagerPersonId = filters.accountManagerPersonId;
        } else {
            this.resetFilters(false);
        }
    }

    handleStatus(value) {
        this.status = !isNaN(+value) ? +value : 0;
    }

    handleWorkers(value) {
        this.assignedUserId = !isNaN(+value) ? +value : 0;
    }

    handleAccountManager(value) {
        this.accountManagerPersonId = !isNaN(+value) ? +value : 0;
    }

    handleContractor(value: number) {
        const contractor = this.contractorsList?.find((el) => el.companyId === +value);
        this.assignedTo = contractor?.userType ?? null;
        this.userTypeCompanyId = !isNaN(+value) ? +value : 0;
    }

    handleCompanyId(value: number) {
        this.companyId = !isNaN(+value) ? +value : 0;
    }

    onListClick() {
        this.showMap.emit(false);
    }

    onMapClick() {
        this.showMap.emit(true);
    }

    onAssignedUserIdChange(event) {}

    onStatusChange(event) {
        this.status = +event;
    }

    onComplaintTypeChange(event) {
        this.complaintType = +event;
    }

    emitFilters(reset = false) {
        this.filtersEmitter.emit({
            filters: {
                assignedUserId: this.assignedUserId,
                client: this.client,
                nrOrder: this.nrOrder,
                distributorOrRetailer: this.distributorOrRetailer,
                status: this.status,
                creationDateFrom: this.creationDateFrom,
                creationDateTo: this.creationDateTo,
                userTypeCompanyId: this.userTypeCompanyId,
                assignedTo: this.assignedTo,
                companyId: this.companyId,
                complaintType: this.complaintType,
                accountManagerPersonId: this.accountManagerPersonId,
            },
            reset,
        });
    }

    resetFilters(emit = true) {
        this.nrOrder = '';
        this.assignedUserId = 0;
        this.accountManagerPersonId = 0;
        this.status = 0;
        this.creationDateFrom = null;
        this.creationDateTo = null;
        this.client = '';
        this.distributorOrRetailer = '';
        this.userTypeCompanyId = this.config.user?.user?.ActiveCompany ? +this.config.user.user.ActiveCompany : 0;
        this.assignedTo = this.complaintService.getUserType();
        this.companyId = 0;
        this.complaintType = 0;
        if (emit) this.emitFilters(true);
    }

    getUserTypeName(type: ComplaintUserType) {
        return this.complaintService.getUserTypeName(type);
    }

    getContractorsList() {
        return this.contractorsList?.filter(
            (contractor) =>
                (this.userType === 'distributor' && contractor.userType === 'authorizedRetailer') ||
                (this.userType === 'manufacturer' &&
                    (contractor.userType === 'distributor' ||
                        contractor.userType === 'authorizedRetailer'))
        );
    }

    assignedToMe() {
        this.assignedUserId = this.config.user.user?.id ?? 0;
        this.userTypeCompanyId = this.config.user.user?.ActiveCompany ? +this.config.user.user?.ActiveCompany : 0;
        this.assignedTo = this.userType
        this.emitFilters(true);
    }
}
